module.exports = __webpack_public_path__ + "static/media/motorcycle.f927d7fc.svg";